<div class="sidenav-filter ui-shadow-2" [ngClass]="{'sidenav-filter-visible': visible && !isMobileDevice(), 'sidenav-filter-visible-mobile': visible && isMobileDevice() }">
  <div class="sidenav-filter-list">
    <mat-icon class="clickable sidenav-toggle" svgIcon="chevron_left" (click)="toggleVisible.emit()"></mat-icon>
    @for (filter of filters; track filter; let i = $index; let first = $first) {
      <div class="margin-top">
        @if (filter.search) {
          <input type="text" #searchFilter placeholder="Search" (keyup)="clear.emit()">
        }
        @if (assetShown !== historicalAsset) {
          <div>
            @if (filter.title !== 'Departments') {
              <div>
                <h3 [ngStyle]="{ 'margin-top.px': first ? 5 : 40}" class="filter-header ellipsis">{{ filter.title }}</h3>
                @if (tableType !== 1  && settings && storage) {
                  <span>Select All <mat-slide-toggle [(ngModel)]="allowProject" (change)="selectProject.emit({name: filter.title, allowProject:allowProject})"></mat-slide-toggle> </span>
                }
                @if (filter.type === filterType.Multi) {
                  <mat-nav-list>
                    @for (entity of (filter.entities | async) | nameSearch:searchFilter?.value; track entity?.id) {
                      <mat-list-item class="filter-item">
                        <mat-checkbox class="filter-checkbox ellipsis" [matTooltip]="filterName(filter, entity)" matTooltipPosition="after" [matTooltipShowDelay]="tooltipDelay"
                        [checked]="isEntityChecked(entity, filter.selectedEntityIds)" (change)="select.emit({name: filter.name, entity: entity, selectType: filter.type})">{{filterName(filter, entity)}}</mat-checkbox>
                      </mat-list-item>
                    }
                  </mat-nav-list>
                } @else {
                  @for (entity of (filter.entities | async) | nameSearch:searchFilter?.value; track entity?.id) {
                    <mat-radio-button name="filter{{i}}" [matTooltip]="filterName(filter, entity)" matTooltipPosition="after" [matTooltipShowDelay]="tooltipDelay"
                      class="flex-column filter-item filter-checkbox"
                      [checked]="isEntityChecked(entity, filter.selectedEntityIds)" (change)="select.emit({entity: entity, selectType: filter.type})">{{filterName(filter, entity)}}
                    </mat-radio-button>
                  }
                }
              </div>
            }
            @if (filter.title === 'Departments') {
              <div>
                <h3 [ngStyle]="{ 'margin-top.px': first ? 5 : 40}" class="filter-header ellipsis">{{ filter.title }}</h3>
                <span>Select All <mat-slide-toggle [(ngModel)]="allowDept" (change)="selectProject.emit({name: filter.title, allowProject:allowDept})"></mat-slide-toggle> </span>
                @if (filter.type === filterType.Multi) {
                  <mat-nav-list>
                    @for (entity of (filter.entities | async) | nameSearch:searchFilter?.value; track entity?.id) {
                      <mat-list-item class="filter-item">
                        <mat-checkbox class="filter-checkbox ellipsis" [matTooltip]="filterName(filter, entity)" matTooltipPosition="after" [matTooltipShowDelay]="tooltipDelay"
                        [checked]="isEntityChecked(entity, filter.selectedEntityIds)" (change)="select.emit({name: filter.name, entity: entity, selectType: filter.type})">{{filterName(filter, entity)}}</mat-checkbox>
                      </mat-list-item>
                    }
                  </mat-nav-list>
                } @else {
                  @for (entity of (filter.entities | async) | nameSearch:searchFilter?.value; track entity?.id) {
                    <mat-radio-button name="filter{{i}}" [matTooltip]="filterName(filter, entity)" matTooltipPosition="after" [matTooltipShowDelay]="tooltipDelay"
                      class="flex-column filter-item filter-checkbox"
                      [checked]="isEntityChecked(entity, filter.selectedEntityIds)" (change)="select.emit({entity: entity, selectType: filter.type})">{{filterName(filter, entity)}}
                    </mat-radio-button>
                  }
                }
              </div>
            }
          </div>
        }
        @if (assetShown === historicalAsset) {
          <div>
            @if (filter.type === filterType.Multi && filter.title === 'Departments') {
              <mat-nav-list>
                <h3 [ngStyle]="{ 'margin-top.px': 5}" class="filter-header ellipsis">{{ filter.title }}</h3>
                <span>Select All <mat-slide-toggle [(ngModel)]="allowDept" (change)="selectProject.emit({name: filter.title, allowProject:allowDept})"></mat-slide-toggle> </span>
                @for (entity of (filter.entities | async) | nameSearch:searchFilter?.value; track entity?.id) {
                  <mat-list-item class="filter-item">
                    <mat-checkbox class="filter-checkbox ellipsis" [matTooltip]="filterName(filter, entity)" matTooltipPosition="after" [matTooltipShowDelay]="tooltipDelay"
                    [checked]="isEntityChecked(entity, filter.selectedEntityIds)" (change)="select.emit({name: filter.name, entity: entity, selectType: filter.type})">{{filterName(filter, entity)}}</mat-checkbox>
                  </mat-list-item>
                }
              </mat-nav-list>
            }
          </div>
        }
      </div>
    }
  </div>
  @if (button) {
    <div style="text-align: center;">
      <button mat-raised-button style="margin: 15px;" (click)="buttonClick.emit($event)" ngClass.xs="mobile-flat-border">{{buttonText}}</button>
    </div>
  }
</div>
